// extracted by mini-css-extract-plugin
module.exports = {"widget":"widget--l8q0g","active":"active--65iuu","widgetHead":"widgetHead--cpy3g","widgetBody":"widgetBody--XvEXI","dark":"dark--Ewu2Z","btn":"btn--t924f"};